import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { WineCollectionSection } from './components/WineCollectionSection';
import { CustomLabelsSection } from './components/CustomLabelsSection';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { CustomLabelDesignPage } from './pages/CustomLabelDesignPage';
import { FAQPage } from './pages/FAQPage';
import { VineyardPage } from './pages/VineyardPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
function HomePage() {
  return <main data-id="element-0">
      <HeroSection data-id="element-1" />
      <AboutSection data-id="element-2" />
      <div className="w-full bg-cream-50 flex items-center justify-center py-16" data-id="element-3">
        <img src="https://cdn.magicpatterns.com/uploads/wm9JygMQ5m6cT2LGSwwYjj/image.png" alt="Hand holding a wine bottle with custom label" className="max-h-[500px] w-auto object-contain" data-id="element-4" />
      </div>
      <HowItWorksSection data-id="element-5" />
      <WineCollectionSection data-id="element-6" />
      <CustomLabelsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <CTASection data-id="element-9" />
      <ContactSection data-id="element-10" />
    </main>;
}
export function App() {
  return <BrowserRouter data-id="element-11">
      <div className="min-h-screen bg-cream font-sans text-brown selection:bg-wine/20 selection:text-wine" data-id="element-12">
        <Navbar data-id="element-13" />
        <Routes data-id="element-14">
          <Route path="/" element={<HomePage data-id="element-16" />} data-id="element-15" />
          <Route path="/design" element={<CustomLabelDesignPage data-id="element-18" />} data-id="element-17" />
          <Route path="/faq" element={<FAQPage data-id="element-20" />} data-id="element-19" />
          <Route path="/vineyard" element={<VineyardPage data-id="element-22" />} data-id="element-21" />
          <Route path="/blog" element={<ComingSoonPage data-id="element-24" />} data-id="element-23" />
        </Routes>
        <Footer data-id="element-25" />
      </div>
    </BrowserRouter>;
}